import { Component, Inject, OnInit } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'custom-popup-message',
  templateUrl: './custom-popup-message.component.html',
  styleUrls: ['./custom-popup-message.component.scss']
})
export class CustomPopupMessageComponent implements OnInit {

    errorMessage: string = "";
    successMessage: string = "";
    infoMessage: string = "";
    displayErrors: boolean = false;
    displaySuccesses: boolean = false;
    displayInformation: boolean = false;

    constructor(public sharedService: SharedService) {
    }

    ngOnInit(): void {
      this.sharedService.showPopupErrorMessage.subscribe(
        (data: any ) => { this.errorMessage = data.error, this.displayErrors = data.displayError}
      );
      this.sharedService.showPopupSuccessMessage.subscribe(
        (data: any ) => { this.successMessage = data.success, this.displaySuccesses = data.displaySuccess }
      );
      this.sharedService.showPopupInfoMessage.subscribe(
        (data: any ) => { this.infoMessage = data.success, this.displayInformation = data.displayInfo }
      );

    }

    ngOnDestroy() {
      this.resetValues();
    }

    cancelClick() {
      this.resetValues();
    }

    resetValues() {
      this.sharedService.showPopupErrorMessage.emit({error: "", displayError: false});
      this.sharedService.showPopupSuccessMessage.emit({success: "",displaySuccess: false});
      this.sharedService.showPopupInfoMessage.emit({info: "",displayInfo: false});
    }

}